import { render, staticRenderFns } from "./tables.vue?vue&type=template&id=8fdb1fea&scoped=true&"
import script from "./tables.vue?vue&type=script&lang=js&"
export * from "./tables.vue?vue&type=script&lang=js&"
import style0 from "./tables.vue?vue&type=style&index=0&id=8fdb1fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdb1fea",
  null
  
)

component.options.__file = "tables.vue"
export default component.exports